import { SlideImage } from 'yet-another-react-lightbox'

import { Image } from '@wwt/entities/api/search-response'

import { getSrcParamsForSlide } from './getSrcParamsForSlide'

export const getSlides = (images: Image[]): SlideImage[] => {
	if (images.length < 1) {
		return [{ src: '' }]
	}
	return images.map(image => ({
		...getSrcParamsForSlide(image.resolution[image.resolution.length - 1]),
		alt: image.description,
		srcSet: image.resolution.map(res => getSrcParamsForSlide(res))
	}))
}
